import { z } from "zod";
export const KASA_OLAY_PAKET_BOYUTU = 50;
/** Serbest metin, gövde, kart veya kişi verisi bu sözleşmeye giremez. */
export const zKasaOlayTemeli = z.object({
    olay: z.enum([
        "satis.kuyruga_alindi", "satis.yerel_hata", "senkron.durum",
        "senkron.yanit", "senkron.hata", "senkron.yeniden_deneme", "senkron.foto_hatasi",
    ]),
    zaman: z.number().int().min(0).max(8_640_000_000_000_000),
    islem_anahtari: z.string().regex(/^\d{1,20}:\d{1,20}$/).optional(),
    iz_id: z.string().uuid().optional(),
    asama: z.enum(["kuyruk", "delta", "heartbeat"]).optional(),
    durum: z.enum(["cevrimici", "cevrimdisi", "senkronlaniyor"]).optional(),
    http_durum: z.number().int().min(100).max(599).optional(),
    deneme: z.number().int().nonnegative().safe().optional(),
    bekleme_ms: z.number().int().nonnegative().safe().optional(),
    offline: z.boolean().optional(),
});
export const zKasaOlayi = zKasaOlayTemeli.extend({ olay_id: z.string().uuid() });
export const zKasaOlayPaketi = z.object({
    terminal_id: z.number().int().positive().safe(),
    olaylar: z.array(zKasaOlayi).min(1).max(KASA_OLAY_PAKET_BOYUTU),
});
export const zKasaOlayOnayi = z.object({
    alinanlar: z.array(z.string().uuid()).max(KASA_OLAY_PAKET_BOYUTU),
});
//# sourceMappingURL=kasaOlayi.js.map